import React, { useState, useEffect } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    setIsMobileMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const menuItems = [
    { label: t('nav.about'), anchor: 'about' },
    { label: t('nav.services'), anchor: 'services' },
    { label: t('nav.approach'), anchor: 'approach' },
    { label: t('nav.contact'), anchor: 'contact' }
  ];


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg py-3' : 'bg-transparent py-6'}`
      }>

      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="transition-all duration-300 hover:scale-105">

          <img
            src="https://customer-assets.emergentagent.com/job_hippopartners/artifacts/n0ek3ihq_Resim2.png"
            alt="Hippo Partners Logo"
            className="h-14 md:h-20 w-auto object-contain" />

        </button>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          {menuItems.map((item) =>
          <button
            key={item.anchor}
            onClick={() => scrollToSection(item.anchor)}
            className="font-medium text-gray-900 hover:text-yellow-600 transition-colors duration-300 hover:scale-105 transform">

              {item.label}
            </button>
          )}
          
          {/* Language Switcher */}
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-2 px-3 py-2 rounded-lg font-medium bg-gray-100 text-gray-900 hover:bg-yellow-100 hover:text-gray-900 transition-all duration-300 hover:scale-105"
          >
            <Globe className="h-4 w-4" />
            <span className="uppercase font-semibold">{language}</span>
          </button>
          
          <Button
            onClick={() => scrollToSection('contact')}
            className={`rounded-full px-6 font-bold transition-all duration-300 transform hover:scale-105 ${
              isScrolled
                ? 'bg-yellow-400 hover:bg-yellow-500 text-gray-900 shadow-lg'
                : 'bg-yellow-400 text-gray-900 hover:bg-yellow-500 shadow-xl'
            }`}
          >
            {t('nav.getQuote')}
          </Button>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center gap-3">
          <button
            onClick={toggleLanguage}
            className={`flex items-center gap-1 px-2 py-1 rounded-lg text-sm font-semibold ${
              isScrolled ? 'bg-gray-100 text-gray-700' : 'bg-yellow-400/80 text-gray-900'
            }`}
          >
            <Globe className="h-4 w-4" />
            {language.toUpperCase()}
          </button>
          
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            style={{ color: isScrolled ? '#1f2937' : '#1f2937' }}>

            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="md:hidden bg-white shadow-lg">
          <nav className="flex flex-col space-y-4 px-6 py-6">
            {menuItems.map((item) =>
          <button
            key={item.anchor}
            onClick={() => scrollToSection(item.anchor)}
            className="text-gray-700 hover:text-yellow-600 font-medium text-left transition-colors">

                {item.label}
              </button>
          )}
            <Button
            onClick={() => scrollToSection('contact')}
            className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 rounded-full font-bold shadow-lg">

              {t('nav.getQuote')}
            </Button>
          </nav>
        </div>
      }
    </header>);

};

export default Header;